export { MODULE_NAME } from './mail-templates.const';
export { store } from './store/mail-template.store';
